// API base URL based on environment
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_VERCEL_API_URL || 'https://api.veridicus.com.br'
  : process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:5000';

// Helper to get auth header
const getAuthHeader = () => {
  return {
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  };
};

// Get all users with pagination
export const fetchUsers = async (page = 1, limit = 10) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/users?page=${page}&limit=${limit}`, {
      headers: getAuthHeader()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('Error response:', errorData);
      throw new Error(errorData.message || `Erro ao carregar usuários: ${response.status}`);
    }
    
    const data = await response.json();
    return {
      users: data.data, // Extract the data array from the response
      totalUsers: data.count || 0,
      currentPage: page,
      totalPages: Math.ceil((data.count || 0) / limit),
      limit: limit
    };
  } catch (error) {
    console.error('Error in fetchUsers:', error);
    throw error;
  }
};

// Create a new user
export const createUser = async (userData) => {
  const response = await fetch(`${API_BASE_URL}/api/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader()
    },
    body: JSON.stringify(userData)
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Erro ao criar usuário');
  }
  
  return await response.json();
};

// Update an existing user
export const updateUser = async (userId, userData) => {
  const response = await fetch(`${API_BASE_URL}/api/users/${userId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader()
    },
    body: JSON.stringify(userData)
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    console.error('Error updating user:', errorData);
    throw new Error(errorData.message || 'Erro ao atualizar usuário');
  }
  
  return await response.json();
};

// Delete a user
export const deleteUser = async (userId) => {
  const response = await fetch(`${API_BASE_URL}/api/users/${userId}`, {
    method: 'DELETE',
    headers: getAuthHeader()
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    console.error('Error deleting user:', errorData);
    throw new Error(errorData.message || 'Erro ao excluir usuário');
  }
  
  return await response.json();
};

// Get email aliases for current user
export const getEmailAliases = async () => {
  const response = await fetch(`${API_BASE_URL}/api/emails/aliases/list`, {
    headers: getAuthHeader()
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Erro ao buscar aliases de email');
  }
  
  return await response.json();
};

// Add email alias
export const addEmailAlias = async (aliasUserId) => {
  const response = await fetch(`${API_BASE_URL}/api/emails/aliases`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader()
    },
    body: JSON.stringify({ aliasUserId })
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Erro ao adicionar alias de email');
  }
  
  return await response.json();
};

// Remove email alias
export const removeEmailAlias = async (aliasUserId) => {
  const response = await fetch(`${API_BASE_URL}/api/emails/aliases/${aliasUserId}`, {
    method: 'DELETE',
    headers: getAuthHeader()
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Erro ao remover alias de email');
  }
  
  return await response.json();
};

